(function () {
  function initChartDrag(modal) {
    var scrollers = Array.prototype.slice.call(modal.querySelectorAll('.ehiw-modal-chart .chart-scroll'));
    scrollers.forEach(function (scroller) {
      if (scroller.getAttribute('data-drag-bound') === 'true') return;
      scroller.setAttribute('data-drag-bound', 'true');

      var isDragging = false;
      var dragMoved = false;
      var dragStartX = 0;
      var dragStartScrollLeft = 0;

      scroller.addEventListener('mousedown', function (e) {
        isDragging = true;
        dragMoved = false;
        dragStartX = e.pageX;
        dragStartScrollLeft = scroller.scrollLeft;
        scroller.classList.add('is-dragging');
      });

      window.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        var delta = e.pageX - dragStartX;
        if (Math.abs(delta) > 3) dragMoved = true;
        scroller.scrollLeft = dragStartScrollLeft - delta;
        e.preventDefault();
      });

      window.addEventListener('mouseup', function () {
        if (!isDragging) return;
        isDragging = false;
        scroller.classList.remove('is-dragging');
      });

      scroller.addEventListener('click', function (e) {
        if (dragMoved) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  }

  function initModal(root) {
    var trigger = root.querySelector('[data-ehiw-modal-open]');
    var modal = root.querySelector('[data-ehiw-modal]');
    var overlay = root.querySelector('[data-ehiw-modal-overlay]');
    if (!modal || !overlay) return;

    var closeBtns = Array.prototype.slice.call(modal.querySelectorAll('[data-ehiw-modal-close]'));

    function openModal(e) {
      if (e) e.preventDefault();
      modal.hidden = false;
      overlay.hidden = false;
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        overlay.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';
      window.dispatchEvent(new Event('resize'));
      initChartDrag(modal);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () {
        modal.hidden = true;
        overlay.hidden = true;
      }, 250);
    }

    if (trigger) {
      trigger.addEventListener('click', openModal);
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    overlay.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ehiw-section]').forEach(function (root) {
      initModal(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ehiw-section]');
    if (root) initModal(root);
  });
})();
